import { Navigate } from "react-router-dom";

//login
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

import AgencyList from "pages/Agency/AgencyList";
import PrepaymentList from "pages/Agency/Prepayment";

import OperatorList from "pages/Operator/Operator";
import RoleList from "pages/Operator/Role";
import UserList from "pages/User";
import OperatorUserProfile from "pages/Operator/Operator/UserProfile";
import IssueList from "pages/RedeemCode/Issue";
import UsageList from "pages/RedeemCode/Usage";

const ROUTES = {
  AGENCY_LIST_MANAGEMENT: "/agency-management",
  AGENCY_EVENT_TRACKING: "/event-tracking-logs",
  AGENCY_PREPAYMENT: "/redeem-code/issue",
  USER_STAR: "/user-star",

  OPERATOR_LIST: "/operator/list",
  OPERATOR_ROLE: "/operator/role",
  OPERATOR_PROFILE: "/operator/profile",
  MANAGEMENT_PROXY: "/operator/proxy",

  DASHBOARD: "/dashboard",
  PROFILE: "/profile",
  PROFILE_SETTING: "/pages-profile-settings",
  OPERATOR_USER_PROFILE: "/user/profile",

  SETTING: "/setting",

  PUSH_NOTIFICATION_PUSH_LOG: "/push-notification/push-log",
  PUSH_NOTIFICATION_MANUAL_PUSH: "/push-notification/manual-push",

  REDEEM_CODE_MANAGEMENT: "/redeem-code",
  REDEEM_CODE_ISSUE: "/redeem-code/issue",
  REDEEM_CODE_USAGE: "/redeem-code/usage",
};

const authProtectedRoutes = [
  { path: ROUTES.AGENCY_LIST_MANAGEMENT, component: <AgencyList /> },
  { path: ROUTES.AGENCY_PREPAYMENT, component: <IssueList /> },
  { path: ROUTES.USER_STAR, component: <UserList /> },
  { path: ROUTES.OPERATOR_LIST, component: <OperatorList /> },
  { path: ROUTES.OPERATOR_ROLE, component: <RoleList /> },
  { path: ROUTES.OPERATOR_USER_PROFILE, component: <OperatorUserProfile /> },

  // { path: ROUTES.SETTING, component: <></> },

  // { path: ROUTES.PUSH_NOTIFICATION_PUSH_LOG, component: <PushLog /> },
  // { path: ROUTES.PUSH_NOTIFICATION_MANUAL_PUSH, component: <ManualPush /> },

  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/agency-management" />,
  },
  { path: "*", component: <Navigate to="/agency-management" /> },
  { path: ROUTES.REDEEM_CODE_MANAGEMENT, component: <IssueList /> },
  { path: ROUTES.REDEEM_CODE_ISSUE, component: <IssueList /> },
  { path: ROUTES.REDEEM_CODE_USAGE, component: <UsageList /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes, ROUTES };
